import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useState } from 'react';
import CopyToClipboardWrapper from './CopyToClipboardWrapper.js';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import { Slide, Box, Button, IconButton, Snackbar } from '@mui/material';

const Copy = ({
  sx,
  value,
  children,
  buttonProps,
  buttonLabel,
  area = true,
  showValue = true,
  multiLine = false,
  iconButton = false
}) => {
  const [state, setState] = useState({
    open: false,
    Transition: Slide
  });
  const handleClick = Transition => () => {
    setState({
      open: true,
      Transition
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      open: false
    });
  };
  value = String(value) || '';
  // iconButton が有効な場合は行数に関わらずアイコンボタンを使用する
  const needMultiLine = !iconButton && (multiLine || value.split('\n').length > 3);
  const link = value && (value.startsWith('http') || value.startsWith('mailto'));
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: needMultiLine ? 'block' : 'flex',
      backgroundColor: area && 'action.hover',
      border: area && '1px solid #ccc',
      ...sx
    }
  }, /*#__PURE__*/React.createElement(CopyToClipboardWrapper, {
    text: String(value) || '',
    onCopy: handleClick(Slide)
  }, needMultiLine ? /*#__PURE__*/React.createElement(Button, _extends({
    sx: {
      width: '100%',
      ...(buttonProps == null ? void 0 : buttonProps.sx)
    },
    variant: (buttonProps == null ? void 0 : buttonProps.variant) || 'contained'
  }, buttonProps), /*#__PURE__*/React.createElement(ContentCopyIcon, {
    sx: {
      mr: 1,
      fontSize: '1rem'
    }
  }), ' ', buttonLabel || 'コピー') : /*#__PURE__*/React.createElement(IconButton, buttonProps, /*#__PURE__*/React.createElement(ContentCopyIcon, null))), showValue && /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: 1,
      my: 'auto',
      p: needMultiLine ? 1 : 0,
      'white-space': 'pre-line',
      'overflow-wrap': 'anywhere'
    }
  }, children || value), link && showValue && /*#__PURE__*/React.createElement(IconButton, {
    sx: {
      ml: 1
    },
    href: value,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(LaunchIcon, null)), /*#__PURE__*/React.createElement(Snackbar, {
    open: state.open,
    onClose: handleClose,
    TransitionComponent: state.Transition,
    message: `コピーしました: ${value}`,
    key: state.Transition.name
  }));
};

export { Copy };
